import { axiosInstance, type CustomResponseFormat } from "api/instance";

export const AI_COMMENT_DOMAIN = "ai/comment";
export const AI_COMMENT_LIST_ENDPOINT = "list";
export const AI_COMMENT_DELETE_ENDPOINT = "delete";

export interface CommentType {
  editorKey: string;
  commentList: { aiCommentKey: string; comment: string }[];
}

export const aiApi = {
  getCommentList: (tk: string, trk?: string) =>
    axiosInstance.get<CustomResponseFormat<CommentType[]>>(
      `${AI_COMMENT_DOMAIN}/${AI_COMMENT_LIST_ENDPOINT}`,
      { params: { tk: tk, trk: trk } }
    ),

  deleteComment: (
    pid: number,
    tk: string,
    data: { aiCommentKey: string },
    trk?: string
  ) =>
    axiosInstance.post<void>(
      `${AI_COMMENT_DOMAIN}/${AI_COMMENT_DELETE_ENDPOINT}`,
      data,
      { params: { pid: pid, tk: tk, trk: trk } }
    ),
};
